import { render, staticRenderFns } from "./paymentAmount.vue?vue&type=template&id=99415052&scoped=true&"
import script from "./paymentAmount.vue?vue&type=script&lang=js&"
export * from "./paymentAmount.vue?vue&type=script&lang=js&"
import style0 from "./paymentAmount.vue?vue&type=style&index=0&id=99415052&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99415052",
  null
  
)

export default component.exports